import React, { useRef, useState } from "react";
import "../replay-app/DeleteDialog.scss";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { toast } from 'react-toastify';

// v2-1574: what the owner does with the replays selected on his channel, after a confirmation that gives their
// number: delete them, or make them public or private. The site acts only on those that are his, and says which.
const ACTIONS = {
  delete: {
    url: "/social/delete-selection.php",
    fields: "",
    title: "chanelApp.selection.deleteTitle",
    confirm: "chanelApp.selection.deleteConfirm",
    warning: "replayApp.deleteReplayMessage",
    button: "chanelApp.selection.delete",
    done: "chanelApp.selection.deleted",
    partial: "chanelApp.selection.deletePartial",
    error: "chanelApp.selection.deleteError"
  },
  public: {
    url: "/social/visibility-selection.php",
    fields: "&visibility=1",
    title: "chanelApp.selection.publicTitle",
    confirm: "chanelApp.filters.allPublicConfirm",
    warning: null,
    button: "chanelApp.filters.confirm",
    done: "chanelApp.selection.madePublic",
    partial: "chanelApp.selection.visibilityPartial",
    error: "chanelApp.filters.allError"
  },
  private: {
    url: "/social/visibility-selection.php",
    fields: "&visibility=0",
    title: "chanelApp.selection.privateTitle",
    confirm: "chanelApp.filters.allPrivateConfirm",
    warning: null,
    button: "chanelApp.filters.confirm",
    done: "chanelApp.selection.madePrivate",
    partial: "chanelApp.selection.visibilityPartial",
    error: "chanelApp.filters.allError"
  }
};

function SelectionActionDialog({
  action,
  handleClose,
  onDone,
  ids,
  token
}) {

  const { t } = useTranslation();
  const [inFlight, setInFlight] = useState(false);
  // the last action asked for: the dialog keeps its texts while it fades out, after action went back to null
  const shown = useRef("delete");
  if (action !== null) {
    shown.current = action;
  }
  const texts = ACTIONS[shown.current];

    const toastOptions = {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: 0,
    };

    // the site takes at most 500 ids a request (PHP drops the fields beyond max_input_vars without a word), and a
    // channel scrolled to the end can offer more: they go in turn, 500 at a time
    const CHUNK = 500;

    const run = () => {
        if (inFlight || ids.length === 0 || action === null) {
            return;
        }
        const todo = ACTIONS[action];
        setInFlight(true);
        const chunks = [];
        for (let i = 0; i < ids.length; i += CHUNK) {
            chunks.push(ids.slice(i, i + CHUNK));
        }
        let done = 0;
        const next = (index) => {
            if (index === chunks.length) {
                setInFlight(false);
                toast.success(t(todo.done, { count: done }), toastOptions);
                onDone();
                return;
            }
            let body = "token=" + encodeURIComponent(token) + todo.fields;
            chunks[index].forEach((id) => {
                body += "&ids%5B%5D=" + encodeURIComponent(id);
            });
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: body
            };
            fetch(window.serverUrl + todo.url, requestOptions)
            .then((r) => r.json())
            .then((resp) => {
                if (resp.error) {
                    throw resp;
                }
                done += resp.count;
                next(index + 1);
            })
            .catch((err) => {
                console.error("selection " + action + " failed", err);
                setInFlight(false);
                // what an earlier request already did is done: told with its number, and the list is fetched again
                // rather than left stale
                if (done > 0) {
                    toast.error(t(todo.partial, { count: done }), toastOptions);
                    onDone();
                } else {
                    toast.error(t(todo.error), toastOptions);
                    handleClose();
                }
            });
        };
        next(0);
    };

  return (
    <Modal
      show={action !== null}
      onHide={() => {
        if (!inFlight) {
          handleClose();
        }
      }}
      backdrop
      keyboard={false}
      centered
      dialogClassName="delete-dialog"
    >
        <Modal.Header closeButton closeLabel={false}>
            <Modal.Title>
          {t(texts.title)}
            </Modal.Title>
        </Modal.Header>
          <Modal.Body>
{t(texts.confirm, { count: ids.length })}
{texts.warning !== null ? (<><br/>{t(texts.warning)}</>) : (<></>)}
        </Modal.Body>
        <Modal.Footer>
            <Button onClick={handleClose} disabled={inFlight}>{t("chanelApp.filters.cancel")}</Button>
            <Button className="delete" onClick={run} disabled={inFlight}>{t(texts.button)}</Button>
        </Modal.Footer>
    </Modal>
  );
}

export default SelectionActionDialog;
